import router from '@/router';
import blobstorageService from '../services/blobstorage.service';

export const BLOB_STORAGE = {
  namespaced: true,
  state: {
    limits: {},
  },
  getters: {
    GET_FACILITY_LIMITS(state) {
      return state.limits;
    },
  },
  mutations: {
    SET_LIMITS(state, value) {
      state.limits = value;
    },
  },
  actions: {
    async GET_LIMITS({ commit }) {
      var facilityId = router.currentRoute.params.id;
      const response = await blobstorageService.getLimitsByFacility(facilityId);
      let limits = response.data;
      commit('SET_LIMITS', limits);
    },
  },
};
